var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIptSvc3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21017 21.9972H47.792V13.6608C47.792 12.2242 46.6195 11.0517 45.1829 11.0517H10.8193C9.38267 11.0517 8.21017 12.2242 8.21017 13.6608V21.9972ZM8.21017 24.4154V46.8154H47.792V24.4154H8.21017ZM10.8193 8.63354H45.1829C47.9463 8.63354 50.2102 10.8974 50.2102 13.6608V49.2335H5.79199V13.6608C5.79199 10.8974 8.05586 8.63354 10.8193 8.63354ZM40.1556 16.5245C40.1556 15.3265 41.1213 14.3608 42.3193 14.3608C43.5172 14.3608 44.4829 15.3265 44.4829 16.5245C44.4829 17.7224 43.5172 18.6881 42.3193 18.6881C41.1213 18.6881 40.1556 17.7224 40.1556 16.5245ZM32.5193 16.5245C32.5193 15.3265 33.485 14.3608 34.6829 14.3608C35.8809 14.3608 36.8465 15.3265 36.8465 16.5245C36.8465 17.7224 35.8809 18.6881 34.6829 18.6881C33.485 18.6881 32.5193 17.7224 32.5193 16.5245ZM24.8829 16.5245C24.8829 15.3265 25.8486 14.3608 27.0465 14.3608C28.2445 14.3608 29.2102 15.3265 29.2102 16.5245C29.2102 17.7224 28.2445 18.6881 27.0465 18.6881C25.8486 18.6881 24.8829 17.7224 24.8829 16.5245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIptSvc3);
export default __webpack_public_path__ + "static/media/ipt_svc3.9210be26a8ba66d656afa4f8b58a71fe.svg";
export { ForwardRef as ReactComponent };